import { useEffect, useState } from "react";
import style from "./RandomWorld.module.css";
import {
  LEVELS
} from './constants';


// Screen Size Hanlders
const findColCount = () => {
  const windowWidth = window.innerWidth;
  const slicesBy20 = Math.floor(windowWidth / 20) - 5;
  const evenNumber = slicesBy20 % 2 === 0 ? slicesBy20 : slicesBy20 - 1;
  const columnCount = evenNumber >= 50 ? 40 : evenNumber;
  return { columnCount, windowWidth };
}

const findRowCount = () => {
  const windowHeight = window.innerHeight / 2;
  const slicesBy20 = Math.floor(windowHeight / 20);
  const evenNumber = slicesBy20 % 2 === 0 ? slicesBy20 : slicesBy20 - 1;
  const rowCount = evenNumber >= 50 ? 40 : evenNumber;
  return { rowCount, windowHeight };
}

const useFeildSize = () => {
  const { columnCount, windowWidth } = findColCount();
  const { rowCount } = findRowCount();

  const totalCells = columnCount * rowCount;

  const startingPosition = (rowCount / 2) + (columnCount / 2);
  return {
    windowWidth,
    columnCount,
    rowCount,
    totalCells,
    startingPosition,
  }
}


// Map Processing
export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}

const baseCells = ["G", "G", "T"];
const forbiddenCells = ["T", "W"];
const collectableCells = ["P"];

const tileSize = 50;

const generateTile = () => {
  const tile = [];

  const cellCount = tileSize * tileSize;
  for (let i = 0; i < cellCount; i++) {
    const randomInt = getRandomInt(0, baseCells.length);
    tile.push(baseCells[randomInt]);
  }
  return tile;
}

const createMatrix = tile => {
  const asArray = [...tile];
  const matrix = [];
  while (asArray.length) {
    matrix.push(asArray.splice(0, tileSize));
  }
  return matrix;
}

// Add Post Matrix Effects
const getRandomCell = (matrix) => {
  const randomY = getRandomInt(0, matrix.length);
  const randomX = getRandomInt(0, matrix[0].length);
  return { x: randomX, y: randomY };
}
const addRandomSingle = ({ matrix, cellType = "W", accessPoints = 0 }) => {
  const { x, y } = getRandomCell(matrix);
  matrix[x][y] = cellType;
  for (let i = 0; i < accessPoints; i++) {
    const xOrY = getRandomInt(0, 1);
    if (xOrY === 0) {
      matrix[x + 1][y] = "G";
    } else {
      matrix[x][y + 1] = "G";
    }
  }
}

const addRandomShape = ({ matrix, cellType = "W", maxWidth = 8, maxHeight = 8 }) => {
  const { x, y } = getRandomCell(matrix);
  // const randomWidth = getRandomInt(0, 10);
  const randomLength = getRandomInt(0, maxHeight);

  for (let iX = 0; iX <= randomLength; iX++) {
    const randomWidth = getRandomInt(0, maxWidth);
    const startOffset = getRandomInt(0, 2);
    for (let i = 0; i <= randomWidth; i++) {
      const newX = x + iX;
      const newY = startOffset + y + i;
      if (newX >= matrix.length || newY >= matrix[0].length) {
        continue;
      } else {
        matrix[newX][newY] = cellType;
      }
    }
  }
}


const prependZero = val => {
  if (val < 10) {
    return `0` + val;
  } else {
    return val;
  }
}

const sliceMatrix = ({ x, y, sizeX, sizeY, matrix }) => {
  const rowsOutward = (sizeY / 2) - 1;
  const colsOutward = (sizeX / 2) - 1;

  const possibleLeftCol = x - colsOutward;
  const possibleRightCol = possibleLeftCol + sizeX;
  const possibleTopRow = y - rowsOutward;
  const possibleBottomRow = possibleTopRow + sizeY;

  const boundries = {
    topRow: possibleTopRow,
    bottomRow: possibleBottomRow,
    leftCol: possibleLeftCol,
    rightCol: possibleRightCol,
  };

  if (possibleLeftCol <= 0) {
    console.log('edge = LEFT');
    boundries.leftCol = 0;
    boundries.rightCol = sizeX;
  }
  if (possibleRightCol >= matrix.length) {
    console.log('edge = RIGHT');
    boundries.rightCol = matrix.length;
    boundries.leftCol = matrix.length - sizeX;
  }
  if (possibleTopRow <= 0) {
    console.log('edge = TOP');
    boundries.topRow = 0;
    boundries.bottomRow = sizeY;
  }
  if (possibleBottomRow >= matrix[0].length) {
    console.log('edge = BOTTOM');
    boundries.bottomRow = matrix[0].length;
    boundries.topRow = matrix[0].length - sizeY;
  }

  const slicedCols = matrix.slice(boundries.topRow, boundries.bottomRow);
  const slicedMatrix = slicedCols.map(row => row.slice(boundries.leftCol, boundries.rightCol));

  return { slicedMatrix, ...boundries };
}

// Display components
const Cell = ({ rowIndex, colIndex, cellValue, positionId }) => {

  const id = `row${rowIndex}col${colIndex}`;
  const activeStyle = positionId === id ? style.active : "";

  return (<td key={colIndex} name={cellValue} id={id} className={`${activeStyle}`}>{cellValue}</td>);
}

const Table = ({ matrix, topRow = 0, leftCol = 0, positionId, handleKeyDown }) => {

  return (
    <>
      <div className={style.splash}>Welcome to Hello Woods! Click to play.</div>
      <table onKeyDown={(e) => handleKeyDown(e)} tabIndex="0" autoFocus={true}>
        <tr>
          <td />
          {matrix[0].map((col, index) => <td key={`col-${index}`} id={`col-${index}`} className={style.coordinateCell}>{prependZero(leftCol + index)}</td>)}
        </tr>
        {matrix.map((row, rowIndex) =>
          <tr key={`row-${rowIndex}`} id={`row-${rowIndex}`} >

            <td className={style.coordinateCell}>{prependZero(topRow + rowIndex)}</td>

            {row.map((cellValue, colIndex) => <Cell key={colIndex} {...{ rowIndex: topRow + rowIndex, colIndex: leftCol + colIndex, cellValue, positionId }} />)}

          </tr>)}
      </table>
    </>
  )
}

//  Controls
const goUp = (prev) => ({ ...prev, y: prev.y - 1 });
const goDown = (prev) => ({ ...prev, y: prev.y + 1 });
const goLeft = (prev) => ({ ...prev, x: prev.x - 1 });
const goRight = (prev) => ({ ...prev, x: prev.x + 1 });

const findPositionId = ({ x, y }) => `row${y}col${x}`
const isForbidden = (nextCell) => forbiddenCells.includes(nextCell);

// Inventory
const generateInventory = (level) => {
  const levelObj = LEVELS[level];
  const inventory = {};
  Object.keys(levelObj).forEach(key => inventory[key] = 0);
  return inventory;
}

const applyLevelCollectables = ({ level, matrix }) => {
  const levelObj = LEVELS[level];
  Object.keys(levelObj).forEach(key => {
    for (let i = 0; i < LEVELS[level][key]; i++) {
      addRandomSingle({ matrix, cellType: key, accessPoints: 1 });
    }
  });
}

const Inventory = ({ inventory, level }) => {

  return (<div className={style.inventory}>
    <div className={style.levelLabel}>Level: {level}</div>
    <ul className={style.inventoryList}>
      {Object.keys(LEVELS[level]).map((item, index) => <li key={`inventory-${index}`}>
        <div name={item} className={style.inventoryItem}> {item} </div> {inventory[item]} / {LEVELS[level][item]}
      </li>)}
    </ul>
  </div>)
}

const useSwipeEvent = ({ handleUp, handleDown, handleLeft, handleRight, handlePickUp }) => {
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)
  const minSwipeDistance = 30

  const onTouchStart = (e) => {
    setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
    const { clientX, clientY } = e.targetTouches[0];
    setTouchStart({ clientX, clientY });
  }

  const onTouchMove = (e) => {
    const { clientX, clientY } = e.targetTouches[0];
    setTouchEnd({ clientX, clientY });
  }

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distanceX = touchStart.clientX - touchEnd.clientX;
    const isLeftSwipe = distanceX > minSwipeDistance;
    const isRightSwipe = distanceX < -minSwipeDistance;
    const distanceY = touchStart.clientY - touchEnd.clientY;
    const isUpSwipe = distanceY > minSwipeDistance;
    const isDownSwipe = distanceY < -minSwipeDistance;

    if (isLeftSwipe) {
      handleRight();
    }
    if (isRightSwipe) {
      handleLeft();
    }

    if (isUpSwipe) {
      handleDown();
    }
    if (isDownSwipe) {
      handleUp();
    }
  }

  const onDblClick = () => {
    handlePickUp();
  }

  return { onTouchStart, onTouchMove, onTouchEnd, onDblClick };
}

const Instructions = () => (
  <div className={style.instructions}>
    <p className={style.desktopInstructions}>Arrows Keys to move. Space Bar to pick up item.</p>
    <p className={style.mobileInstructions}>Swipe to move. Double Tap to pick up item.</p>
  </div>
)

export const RandomWorldBody = ({ matrix }) => {
  const [, setLastKey] = useState(null);
  const { rowCount, columnCount } = useFeildSize();
  const centerX = columnCount / 2;
  const centerY = rowCount / 2;

  const [position, setPosition] = useState({ x: centerX, y: centerY });
  const [level, setLevel] = useState(1);
  const [inventory, setInventory] = useState(generateInventory(level));

  const positionId = findPositionId(position);

  const { slicedMatrix, topRow, leftCol } = sliceMatrix({ ...position, sizeX: columnCount, sizeY: rowCount, matrix });

  const handleUp = () => {
    if (position.y === 0) return;
    const nextPosition = goUp(position);
    const nextCell = matrix[nextPosition.y][nextPosition.x];
    if (isForbidden(nextCell)) return;
    setPosition(nextPosition);
  }
  const handleDown = () => {
    if (position.y === (matrix[0].length - 1)) return;
    const nextPosition = goDown(position);
    const nextCell = matrix[nextPosition.y][nextPosition.x];
    if (isForbidden(nextCell)) return;
    setPosition(nextPosition);
  }
  const handleLeft = () => {
    if (position.x === 0) return;
    const nextPosition = goLeft(position);
    const nextCell = matrix[nextPosition.y][nextPosition.x];
    if (isForbidden(nextCell)) return;
    setPosition(nextPosition);
  }
  const handleRight = () => {
    if (position.x === (matrix.length - 1)) return;
    const nextPosition = goRight(position);
    const nextCell = matrix[nextPosition.y][nextPosition.x];
    if (isForbidden(nextCell)) return;
    setPosition(nextPosition);
  }

  const handlePickUp = () => {
    const thisCell = matrix[position.y][position.x];
    const isCollectable = collectableCells.includes(thisCell);
    if (isCollectable) {
      matrix[position.y][position.x] = "G";
      setInventory(prev => ({ ...prev, [thisCell]: parseInt(prev[thisCell], 10) + 1 }));
    }
  }

  const { onTouchStart, onTouchMove, onTouchEnd, onDblClick } = useSwipeEvent({ handleUp, handleDown, handleLeft, handleRight, handlePickUp });

  useEffect(() => {
    const clearedLevel = Object.keys(LEVELS[level]).every(key => inventory[key] >= LEVELS[level][key]);
    if (clearedLevel) {
      const newLevel = level + 1;
      setLevel(newLevel);
      const newInventory = generateInventory(newLevel);
      setInventory(newInventory)
      applyLevelCollectables({ level: newLevel, matrix });
    }
  }, [inventory, level, matrix]);

  const handleKeyDown = (event) => {
    event.preventDefault();
    setLastKey(event.keyCode);

    if (event.keyCode === 39) { // RIGHT
      handleRight();
    }
    if (event.keyCode === 38) { // UP
      handleUp();
    }
    if (event.keyCode === 37) { // LEFT
      handleLeft();
    }
    if (event.keyCode === 40) { // DOWN
      handleDown();
    }
    if (event.keyCode === 32) { // SPACE
      handlePickUp();
    } else {
      return;
    }
  };

  return (
    <div className={style.pageWrapper} onDoubleClick={() => onDblClick()} {...{ onTouchStart, onTouchMove, onTouchEnd }}>
      <div className={style.boardWrapper}>
        <div className={style.header}>
          <div>
            <h1>Hello Woods</h1>
          </div>
          <div className={style.versionNumber}>Version 0.1</div>
        </div>
        <Table  {...{ matrix: slicedMatrix, topRow, leftCol, positionId, handleKeyDown }} />
        <Inventory {...{ inventory, setInventory, level }} />
      </div>

      <Instructions />
    </div>
  );
}

export const RandomWorld = () => {
  const tile = generateTile();

  const matrix = createMatrix(tile);

  addRandomSingle({ matrix });
  addRandomShape({ matrix, cellType: "W" });
  addRandomShape({ matrix, cellType: "W" });
  addRandomShape({ matrix, cellType: "W", maxWidth: 20 });
  addRandomShape({ matrix, cellType: "W" });
  addRandomShape({ matrix, cellType: "R" });
  addRandomSingle({ matrix, cellType: "P" });

  return <RandomWorldBody {...{ matrix }} />;
}